import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import '../style/style.css';

let column1 = '';
let column2 = '';

function divideText(text) {
  let middle = Math.floor(text.length / 2);
  const before = text.lastIndexOf(' ', middle);
  const after = text.indexOf(' ', middle + 1);

  if (middle - before < after - middle) {
    middle = before;
  } else {
    middle = after;
  }

  column1 = text.substr(0, middle);
  column2 = text.substr(middle + 1);
}
export default function AboutUs({ text }) {
  const { t } = useTranslation();

  divideText(text);
  return (
    <div className="section about" id="sobre">
      <h1 className="title">{t('about')}</h1>
      <div className="row" style={{ whiteSpace: 'pre-wrap' }}>
        <div style={{ width: '50%', whiteSpace: 'pre-wrap' }} className="aboutText half">
          {column1}
        </div>
        <div style={{ width: '50%', whiteSpace: 'pre-wrap' }} className="aboutText half">
          {column2}
        </div>
        <div style={{ width: '100%' }} className="aboutText all">
          {text}
        </div>
      </div>
    </div>
  );
}

AboutUs.propTypes = {
  text: PropTypes.string.isRequired,
};
